export function resolveContactEndpoint(configuredEndpoint = import.meta.env.PUBLIC_CONTACT_ENDPOINT): string {
  if (!configuredEndpoint) return "/api"

  try {
    const endpoint = new URL(configuredEndpoint)
    if (endpoint.hostname === "localhost" || endpoint.hostname === "127.0.0.1") return "/api"
    if (endpoint.hostname.endsWith(".execute-api.ap-northeast-1.amazonaws.com")) return "/api"
    return configuredEndpoint
  } catch {
    return configuredEndpoint.startsWith("/") ? configuredEndpoint : "/api"
  }
}
